// extracted by mini-css-extract-plugin
export default {"certificationPage":"CertificationPage_certificationPage__y4k01","clickable":"CertificationPage_clickable__RhBIQ"};